import { gql } from '@apollo/client';

export const ONLY_PACK_ONBOARDING_MUTATION = gql`
  mutation OnlyPackOnboarding($data: OnlyPackOnboardingInput!) {
    onlyPackOnboarding(data: $data) {
      claimChildAccountTransaction {
        transactionHash
      }
      mintPackTransaction {
        transactionHash
      }
    }
  }
`;
